import React from "react";
import KPICard, { type KPICardProps } from "./KPICard";

type CriticalFindingsKPIProps = Omit<KPICardProps, "groupBy" | "severity">;

const CriticalFindingsKPI: React.FC<CriticalFindingsKPIProps> = ({
  selectedScope,
  filterToExecute,
  scopeToExecute,
  widgetKey,
  setIsReadyToExport = null,
}) => {
  return (
    <KPICard
      selectedScope={selectedScope}
      filterToExecute={filterToExecute}
      scopeToExecute={scopeToExecute}
      groupBy={["finding.severity"]}
      severity={3}
      widgetKey={widgetKey}
      setIsReadyToExport={setIsReadyToExport}
    />
  );
};

export default CriticalFindingsKPI;
